// SinglePropertyLayoutTab/components/FieldModal.js (Simplified version)
import { __ } from '@wordpress/i18n';
import FieldOptions from '../FieldOptions';
import ModalHeader from '../ModalHeader';
import ModalOverlay from '../ModalOverlay';

const FieldModal = ({ 
  modalId, 
  isActive, 
  onClose, 
  onFieldSelect,
  title = __("Insert Element", "havenlytics"),
  options,
  usedFields = [],
  allowReplace = false
}) => {
  if (!isActive) return null;

  // For gallery area, don't filter used fields since we allow replacement
  // For other areas, filter out already used fields
  const availableOptions = allowReplace 
    ? options 
    : options.filter(option => 
        !usedFields.some(usedField => 
          usedField.type.toLowerCase() === option.type.toLowerCase()
        )
      );

  const handleFieldSelect = (option) => {
    onFieldSelect(option.type, modalId);
    // REMOVED the automatic close - modal stays open
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <ModalOverlay onClose={handleClose}>
      <ModalHeader 
        title={title} 
        onClose={handleClose} 
      />
      <div className="hvnly--builder---api_property__singleProperty__builder___option_card_body">
        {availableOptions.length > 0 ? (
          <>
            {allowReplace && usedFields.length > 0 && (
              <div className="hvnly--builder---api_property__singleProperty__builder___replace_notice">
                <i className="fas fa-info-circle"></i>
                <span>{__("Selecting a new option will replace the current gallery type", "havenlytics")}</span>
              </div>
            )}
            <FieldOptions 
              options={availableOptions}
              onSelect={handleFieldSelect}
              usedFields={allowReplace ? [] : usedFields}
            />
          </>
        ) : (
          <div className="hvnly--builder---api_property__singleProperty__builder___no_options">
            <i className="fas fa-check-circle"></i>
            <p>{__("All available fields have been added to this area", "havenlytics")}</p>
            <small>{__("Remove some fields to see more options", "havenlytics")}</small>
          </div>
        )}
      </div>
    </ModalOverlay>
  );
};

export default FieldModal;